import propTypes from "prop-types";
import React, {useState, useEffect} from "react";
import { FormTextInput } from "../core";
import { SuccessIcon, ErrorIcon } from "../core/Icons";

export const OtpModal = ({
  isOpen,
  onClose,
  header,
  onOtpChange,
  otpValue,
  isOtpVerified,
  loading,
  onSearch,
}) => {
  const [secondsLeft, setSecondsLeft] = useState(600)
  useEffect(()=>{
    const timer = setInterval(()=>{
      setSecondsLeft((prev)=> {
        if(prev <= 1){
          clearInterval(timer)
          onClose()
          return 0
        }
        return prev-1
      })
    }, 1000)
    return () => clearInterval(timer)
  }, [onClose])

  useEffect(()=>{
    setSecondsLeft(600)
  }, [isOpen])

  const formatTime = (secs) => {
    const minutes = String(Math.floor(secs/60)).padStart(2, "0");
    const seconds = String(secs%60).padStart(2, "0");
    return `${minutes}:${seconds}`
  }

  const closeOtpModal = () => {
    onClose()
    setSecondsLeft(600)
  }

  return (
    isOpen && (
      <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
        <div className="bg-white p-6 rounded-lg w-1/4">
          <h2 className="text-xl text-center font-semibold mb-4">{header}</h2>
          <p className="mb-5 text-teal-600 text-center">{`OTP is valid for ${formatTime(secondsLeft)}`}</p>
          <div className="mb-4 relative w-full max-w-sm">
            <div className="flex items-center rounded-md">
              <FormTextInput
                labelName="Enter One Time Password"
                id="otp"
                maxLength={6}
                value={otpValue}
                onChange={onOtpChange}
                required={true}
              />
              <div className="-ml-8 mt-6">
              {(otpValue && otpValue.length === 6 && loading) && (
                isOtpVerified ? (
                  <SuccessIcon className="h-5 w-5 text-green-500 ml-2" />
                ) : (
                  <ErrorIcon className="h-5 w-5 text-red-500 ml-2" />
                )
              )}
              </div>
            </div>
            {(otpValue && otpValue.length===6 && loading) && (isOtpVerified ? (<span className="text-teal-700 text-sm mt-2">OTP is valid, You can now search record</span>) : (<span className="text-red-500 text-sm mt-2">Please enter valid OTP</span>))}
          </div>

          <div className="flex justify-between mb-4">
            <button
              type="button"
              className="px-4 py-2 bg-teal-600 hover:bg-teal-700"
              onClick={closeOtpModal}
            >
              Cancel
            </button>
            <button
              type="button"
              className={`px-4 py-2 bg-sky-800 text-white hover:bg-sky-900 ${!isOtpVerified ? "opacity-50 cursor-not-allowed" : ""}`}
              onClick={onSearch}
              disabled={!isOtpVerified}
            >
              Search
            </button>
          </div>
        </div>
      </div>
    )
  );
};

OtpModal.propTypes = {
  isOpen: propTypes.bool.isRequired,
  onClose: propTypes.func.isRequired,
  header: propTypes.string,
  onOtpChange: propTypes.func.isRequired,
  otpValue: propTypes.string.isRequired,
  isOtpVerified: propTypes.bool.isRequired,
  loading: propTypes.bool.isRequired,
  onSearch: propTypes.func.isRequired,
};
